export default {
  amount: "Amount",
  successPendingVerification: "Payment Pending Verification",
  successHeading: "Payment Successful",
  transaction: "Transaction",
  invoice: "Invoice",
  transactionTime: "Transaction Time",
  cannotFetchPaymentTransaction:
    "We ran into an issue fetching your payment transaction. Please try again later.",
  paymentReceived: "Payment received",
  invoicePaidInFull: "Invoice {{number}} is paid in full.",
  invoicePartialPayment: "Partial payment received for invoice {{number}}.",
  paidToVendorOn: "Paid to {{vendor}} on {{date}}",
  receiptNumber: "Receipt number",
  datePaid: "Date paid",
  amountPaid: "Amount paid",
  payBalance: "Pay balance",
  downloadReceipt: "Download receipt",
  questions: "Questions?",
  contactVendor: "Contact {{vendor}}",
  processingTitle: "Processing your payment",
  chargingAmount: "Charging {{amount}}",
  keepWindowOpen: "Secure & encrypted — please keep this window open.",
};
